pds-modal-footer {
  display: block;
  width: 100%;
}

.pds-modal__footer {
  width: 100%;
}
